import "../styles/components/_categoriesSidebar.scss";

class Categories {
  constructor() {
    this.categoriesParent = document.getElementById("js-categories-sidebar");
    this.categoriesToggler = document.getElementById("js-categories-toggler");
    this.categoriesCloseBtn = document.getElementById(
      "js-close-categories-sidebar"
    );

    if (this.categoriesParent) {
      this.offcanvas = new bootstrap.Offcanvas(this.categoriesParent);
      this.accordionTriggers =
        this.categoriesParent.querySelectorAll(".accordion-header");
    } else if (this.categoriesToggler) {
      this.categoriesToggler.style.display = "none";
    }
  }

  closeChildAccordionsOnParentClose() {
    for (const item of this.accordionTriggers) {
      item.addEventListener("click", () => {
        const liItem = item.closest("li");
        const innerItems = liItem.querySelectorAll(
          ".accordion-body .accordion-header"
        );
        for (const trigger of innerItems) {
          if (!trigger.classList.contains("collapsed")) {
            trigger.click();
          }
        }
      });
    }
  }

  listenToggler() {
    this.categoriesToggler.addEventListener("click", () => {
      this.offcanvas.toggle();
    });
  }

  onCloseSidebar() {
    this.categoriesCloseBtn.addEventListener("click", () => {
      this.offcanvas.hide();
    });
  }

  onCategoryClick() {
    const links = this.categoriesParent.querySelectorAll("[data-link]");

    for (let link of links) {
      link.addEventListener("click", () => {
        const href = link.getAttribute("data-link");
        location.assign(href);
      });
    }
  }

  onOffCanvasCloseCollapseAll() {
    this.categoriesParent.addEventListener("hidden.bs.offcanvas", (event) => {
      for (let trigger of this.accordionTriggers) {
        if (!trigger.classList.contains("collapsed")) {
          trigger.click();
        }
      }
    });
  }

  init() {
    if (!this.categoriesParent) return;

    this.closeChildAccordionsOnParentClose();
    this.listenToggler();
    this.onCloseSidebar();
    this.onCategoryClick();
    this.onOffCanvasCloseCollapseAll();
  }
}

export default Categories;
